import { GameLobbyLayout } from '../../components/game-layout'
import { LobbyLayout } from '../../components/lobby-layout'
import { useStore } from '../../store/basic-store'
import { GameLobbyStore, User, ZoneId } from '../../types'
import { useOnLoad } from '../../hooks/lifecycle'
import { joinGameZoneAction } from '../../service/game.action'

export function TradewarsLobby() {
  const lobby = useStore<GameLobbyStore>(`${ZoneId.TRADEWARS}-lobby`)
  const user = useStore<User>('user')
  console.log('user: ', user)
  console.log('lobbyResponse: ', lobby)

  useOnLoad(() => {
    if (user) {
      joinGameZoneAction(ZoneId.TRADEWARS)
    }
  })

  return (
    <GameLobbyLayout id={ZoneId.TRADEWARS} name="Tradewars Empires">
      <LobbyLayout zoneId={ZoneId.TRADEWARS} games={lobby?.games || []} />
    </GameLobbyLayout>
  )
}
